<template>
  <div id="app-home" ref="home">
    <system-tip />
    <home-video />
    <!-- 顶部信息 -->
    <index-top-info />
    <!-- 内容部分 -->
    <div class="main">
      <!-- 左侧部分 -->
      <index-main-left />
      <!-- 右侧部分 -->
      <index-main-right />
    </div>

    <!-- 切换企业 -->
    <index-switch-company />
  </div>
</template>

<script>
import { getCookie } from '@/assets/cookie.js';
let components = {};
const conf = [
  'systemTip',
  'homeVideo',
  'indexTopInfo',
  'indexMainRight',
  'indexMainLeft',
  'indexSwitchCompany',
];
conf.forEach(item => (components[item] = require('./components/' + item + '.vue').default));
// import minxins from './minxins'
export default {
  components,
  // mixins: [minxins],
  async beforeCreate() {
    if (getCookie('redirect')) {
      document.cookie =
        'redirect=' +
        'authentication' +
        ';expires=' +
        new Date(0).toUTCString() +
        '; path=/' +
        ';domain=' +
        window.location.host.substring(window.location.host.indexOf('.'));
      window.location.href = window.location.origin + '/admin/authentication/index';
    }
  },
  async created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))),
      );
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state));
    });
  },
};
</script>
<style lang="scss" scoped>
#app-home {
  padding: 20px;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', 'Arial,sans-serif' !important ;
}
.main {
  position: relative;
}
</style>
